import { RocketLeaguePlayerData, rocketLeagueStatsMock, rocketLeagueStatsMock2 } from '../models/RocketLeaguePlayerData';
import { local } from '../../../../mixins/environment';
import axios from 'axios';
import store from '../../../index';

const actionNameErrorsMap = {
  'general': 'getGeneralStats',
  'rank': 'getRankStats',
  'activity': 'getActivityStats',
};

export default {
  getProfileData(boomAccountId) {
    const url = `${store.state.app.config.baseUrl}/api/v1/rocketLeague/profile/`;

    if (!local) {
      return axios.get(
        url,
        { params: { boomAccountId }}
      ).then(({ data }) => {
        const queues = data.general ? data.general.queues : undefined;
        const rankProgression = data.activity ? data.activity.rankProgression : undefined;
        return {
          gameStats: new RocketLeaguePlayerData({
            ...data,
            queues,
            rankProgression,
          }),
          actionNameErrors: data.errors.map(error => actionNameErrorsMap[error]),
        };
      }).catch(() => {
        throw new Error('error');
      });
    }

    return new Promise((resolve, reject) => {
      setTimeout(() => {
        const response = boomAccountId !== 9999999 ? { ...rocketLeagueStatsMock } : { ...rocketLeagueStatsMock2 };

        let errors = []; // Possible errors: ['activity', 'general', 'rank' ];

        // Just for testing compare failures
        if (boomAccountId === 9999999) {
          // errors = ['general'];
        }

        errors = errors.map(error => actionNameErrorsMap[error]);

        const queues = response.general ? response.general.queues : undefined;
        const rankProgression = response.activity ? response.activity.rankProgression : undefined;
        resolve({
          gameStats: new RocketLeaguePlayerData({
            ...response,
            queues,
            rankProgression,
          }),
          actionNameErrors: errors,
        });
      }, 1000);
    });
  },

  getActivityStats(boomAccountId) {
    const url = `${store.state.app.config.baseUrl}/api/v1/rocketLeague/profile/activity`;

    if (!local) {
      return axios.get(
        url,
        { params: { boomAccountId }}
      ).then(({ data }) => {
        return data;
      }).catch(() => {
        throw new Error('error');
      });
    }

    return new Promise((resolve, reject) => {
      setTimeout(() => {
        const response = rocketLeagueStatsMock.activity;

        resolve(response);
      }, 800);
    });
  },

  getGeneralStats(boomAccountId) {
    const url = `${store.state.app.config.baseUrl}/api/v1/rocketLeague/profile/general`;

    if (!local) {
      return axios.get(
        url,
        { params: { boomAccountId }}
      ).then(({ data }) => {
        return { ...data, queues: data.queues };
      }).catch(() => {
        throw new Error('error');
      });
    }

    return new Promise((resolve, reject) => {
      setTimeout(() => {
        const response = rocketLeagueStatsMock.general;

        resolve({ ...response, queues: response.queues });
      }, 800);
    });
  },

  getRankStats(boomAccountId) {
    const url = `${store.state.app.config.baseUrl}/api/v1/rocketLeague/profile/rank`;

    if (!local) {
      return axios.get(
        url,
        { params: { boomAccountId }}
      ).then(({ data }) => {
        return data;
      }).catch(() => {
        throw new Error('error');
      });
    }

    return new Promise((resolve, reject) => {
      setTimeout(() => {
        const response = rocketLeagueStatsMock.rank;

        resolve(response);
      }, 800);
    });
  },

};
